
import { Base } from '../base-component';
import './interest-rates.component.scss';

import axios, {
	AxiosResponse,
	AxiosPromise,
	AxiosRequestConfig
} from 'axios';

export class InterestRates extends Base {

	containerApi: any;
	apiJson: any;
	containerApiTitle: any;
	containerApiArrow: any;
	containerApiValue: any;
	containerApiTimeStamp: any;

	constructor(element: Element){

		super(element);

	}

	init(){

		if(this.element.querySelector('.js-standard-bank-share-price__title')){

			this.containerApiTitle = this.element.querySelector('.js-standard-bank-share-price__title');
			this.containerApiArrow = this.element.querySelector('.js-standard-bank-share-price__arrow');
			this.containerApiValue = this.element.querySelector('.js-standard-bank-share-price__value');
			this.containerApiTimeStamp = this.element.querySelector('.js-standard-bank-share-price__timestamp');
			this.apiSharePrice();

		}

	}

	bindEvents() {

	}

	apiSharePrice() {

		let url = "https://feeds.standardbank.com/Market-Data-Files/TRKD/Shares.JSON";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}
		axios.get(url).then( (response) => {

			this.apiJson = response.data.shares;
			// this.containerApiTitle.innerHTML = this.apiJson[3].CF_NAME;
			this.containerApiTitle.innerHTML = 'Standard Bank Share Price';
			this.containerApiValue.innerHTML = this.apiJson[3].value;
			this.containerApiTimeStamp.innerHTML = '';
			if(this.apiJson[0].CF_NETCHNG < 0){
				// this.containerApiArrow.innerHTML = `
				// <i data-component="icon" data-icon="icon-arrow-down-red" data-gradient="" data-path="/file_source/assets/icons/" class="icon "><svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28">
				// 	<path fill="#D0021B" fill-rule="nonzero" d="M.5 16.35l1.627-1.65 8.714 8.834V0h2.302v23.534l8.73-8.85 1.627 1.65L11.992 28 .5 16.35"></path>
				// </svg></i>`;
			}else{
				// this.containerApiArrow.innerHTML = `
				// <i data-component="icon" data-icon="icon-arrow-up-green" data-gradient="" data-path="/file_source/assets/icons/" class="icon "><svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28">
				// 	<path fill="#00AD6C" fill-rule="nonzero" d="M.5 11.65l1.627 1.65 8.714-8.834V28h2.302V4.466l8.73 8.85 1.627-1.65L11.992 0 .5 11.65"></path>
				// </svg></i>`;
			}

		}).catch( (error) => {

			console.log(error);

		});

	}

}


// WEBPACK FOOTER //
// ./components/interest-rates/interest-rates.component.ts